import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
import Swiper from 'swiper';
import { Autoplay, EffectFade } from 'swiper/modules';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import smoothscroll from 'smoothscroll-polyfill';
import { buttons } from './modules/buttons';
import { animations } from './modules/animations';

// Swiper Configuration
import 'swiper/css';
import 'swiper/css/effect-fade';

window.Swiper = Swiper;
Swiper.use([Autoplay]);
Swiper.use([EffectFade]);

// GSAP Configuration
gsap.registerPlugin(ScrollTrigger);
window.gsap = gsap;
window.ScrollTrigger = ScrollTrigger;

// Smooth Scroll polyfill for Safari (iOS)
smoothscroll.polyfill();

// Alpine Configuration
window.Alpine = Alpine;
Alpine.plugin(collapse);
Alpine.start();

// Initialize animations
document.addEventListener('DOMContentLoaded', () => {
	buttons();
	animations();
});
